<template>
  <v-card height="90vh" id="inventory-operations">
    <v-card-title :class="headerStyle">
      <v-row no-gutters>
        <span class="headline">
          {{$t('inventoryOperations')}}
        </span>
        <v-spacer/>
        <DeckSelector
        v-show="currentTab != 1"
        class="mr-3 mt-n1 mb-1"
        showEntitySelector
        :showAll="false"
        :propInitialLocationId="initialLocationId"
        :propDeckId="deck?.deckId"
        @deck-selected="deckSelected"
        @location-selected="locationSelected"
        @entity-selected="entitySelected"
        :contentType="contentType.value"
        :disabled="currentTab === 1"
        :showDeckSelector="currentTab !== 2"
        cardTitle/>
        <BaseDialogActions
        @close="$emit('close')"
        @refresh="triggerRefresh"
        />
      </v-row>
    </v-card-title>
    <v-card-text class="mt-6">
      <v-row>
        <v-col cols="12">
          <v-tabs
          id="consumption-tabs"
          v-model="currentTab">
            <v-tab>
              <span>
                {{$t('consumeOrTransfer')}}
              </span>
            </v-tab>
            <v-tab>
              <span>
                {{$t('consumed')}}
              </span>
            </v-tab>
            <v-tab id="decks">
              {{ $t('decks') }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="currentTab" class="mt-4" touchless>
            <v-tab-item class="fill-height">
              <ConsumeTickets
                v-if="!loading"
                :refreshFlag="refreshFlag"
                :productIdDictionary="productIdDictionary"
                :contractMode="contractMode"
                :deck="deck"
                :entity="entity"
                :initialLocationId="initialLocationId"
                @trigger-refresh="triggerRefresh"
              />
              <Loading
              v-if="loading"/>
            </v-tab-item>
            <v-tab-item>
              <ConsumedTickets
                v-if="!loading"
                :productIdDictionary="productIdDictionary"
                :refreshFlag="refreshFlag"
                :contractMode="contractMode"
                :deck="deck"
                :entity="entity"
                @trigger-refresh="triggerRefresh"
              />
              <Loading
              v-if="loading"/>
            </v-tab-item>
            <v-tab-item>
              <Decks
              class="mt-n5"
              v-if="location != null"
              :refreshFlag="refreshFlag"
              :location="location"
              :decks="decksByContentType"
              readonly/>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { colorClassForContractMode } from '../../../utils/componentHelpers'
import { DeckContentType, ContractMode } from '../../../utils/Enumerations'
import { LocalStorageKeys } from '@/utils/LocalStorageActor'
export default {
  name: 'Consumption',

  components: {
    Decks: () => import('@/components/settings-components/decks/Decks.vue'),
    DeckSelector: () => import('@/components/dashboard/DeckSelector.vue'),
    ConsumeTickets: () => import('@/components/ticket/ticket-consumption/ConsumeTickets.vue'),
    ConsumedTickets: () => import('@/components/ticket/ticket-consumption/ConsumedTickets.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    Loading: () => import('@/components/core/Loading.vue')
  },

  props: {
    contractMode: {
      type: Object,
      default: undefined
    }
  },

  data: () => ({
    dialogId: 'consumption',
    currentTab: 0,
    loading: true,
    refreshFlag: false,
    productIdDictionary: {},
    deck: undefined,
    location: undefined,
    entity: undefined,
    initialLocationId: undefined,
    initialized: false
  }),

  computed: {
    headerStyle () {
      return colorClassForContractMode(this.contractMode.value)
    },
    contentType () {
      return this.contractMode === undefined || this.contractMode.value !== ContractMode.Byproducts.value
        ? DeckContentType.Logs
        : DeckContentType.Byproducts
    },
    decksByContentType () {
      return this.location.decks.filter(d => d.contentType === this.contentType.value)
    }
  },

  created () {
    this.createProductDictionary()
    const localStorageInitialLocation = localStorage.getItem(LocalStorageKeys.INVENTORY_OPERATIONS_LOCATION)
    if (localStorageInitialLocation) {
      this.initialLocationId = parseInt(localStorageInitialLocation)
    }
    this.initialized = true
  },

  methods: {
    ...mapActions('product', ['fetchProducts']),

    async createProductDictionary () {
      this.loading = true

      const requestObj = {
        contractId: undefined,
        includedByProduct: true,
        includeProduction: true
      }

      const products = await this.fetchProducts(requestObj)
      products.forEach(p => {
        this.productIdDictionary[p.name] = p
      })

      this.loading = false
    },

    triggerRefresh () {
      this.refreshFlag = true

      this.$nextTick(() => {
        this.refreshFlag = false
      })
    },

    deckSelected (deck) {
      this.deck = deck
    },

    entitySelected (entity) {
      this.entity = entity
    },

    locationSelected (location) {
      this.location = location
      this.initialLocationId = location.locationId
      localStorage.setItem(LocalStorageKeys.INVENTORY_OPERATIONS_LOCATION, JSON.stringify(this.location.locationId))
    }
  }
}
</script>
